import { gql } from 'apollo-angular';
import { TaskType } from '../../../task/entities/taskType';


export const TASKTYPES_QUERY = gql`
query taskTypesQuery
{
  taskTypes: getTaskTypes(
    filter: {}
  )
  {
    code
    name
    prefix
    icon
    color
    isSystem
    isActive
  }
}
`;

export interface TaskTypesQueryResponse {
  loading: boolean;
  taskTypes: TaskType[];
}
